module.exports = __webpack_public_path__ + "img/upTem.bdfc9223.svg";